import moment from 'moment';

export function getChartData(itemKey, requests) {
  let filteredByType;
  switch (itemKey) {
    case 'all':
      filteredByType = requests;
      break;
    case 'active':
      filteredByType = requests.filter((req) => req.status === 'Новая');
      break;
    case 'immediate':
      filteredByType = requests.filter((req) => req.isImmediate);
      break;
    case 'expired':
      filteredByType = requests.filter((req) => {
        const isNotCompleted =
          req.status !== 'Выполнена' || req.status !== 'Закрыта';
        const isExpired = moment(req.executeDateTime).isBefore(moment());
        return isNotCompleted && isExpired;
      });
      break;
    default:
      filteredByType = requests;
  }

  const groupedByDay = {};
  filteredByType.forEach((r) => {
    const dayString = r?.createDateTime?.slice(0, 10);
    groupedByDay[dayString] = (groupedByDay[dayString] || 0) + 1;
  });

  const chartData = Object.entries(groupedByDay).map(([day, count]) => ({
    x: day,
    y: count,
  }));

  return chartData;
}
